import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { DataService } from 'src/app/shared/data.service';
import { HttpClient } from '@angular/common/http';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { Router } from '@angular/router';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  contactUsForm: FormGroup;
  checkedPrivacyAndTerms: boolean;
  public badge: 'bottomright' | 'bottomleft' | 'inline' = 'bottomright';
  public type: 'image' | 'audio';
  public theme: 'light' | 'dark' = 'light';

  public recaptcha: any = null;

  @ViewChild('captchaElem', { static: false }) captchaElem: InvisibleReCaptchaComponent;

  constructor(public utils: UtilsService, private dialog: MatDialog, private dataService: DataService,
              private http: HttpClient, private router: Router) { }

  ngOnInit(): void {
    this.utils.setTitle('Contact Us');
    this.utils.screenTitle.emit({firstTitle: 'Contact us', firstRoute: '/contact-us'});
    this.contactUsForm = new FormGroup({
      name: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
      message: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  handleReset() {
  }

  handleReady() {
  }

  handleLoad() {

  }

  handleSuccess(event: any) {
    const payload = {
      fullName: this.contactUsForm.get('name').value,
      email: this.contactUsForm.get('email').value,
      message: this.contactUsForm.get('message').value
    };
    this.dataService.post('ContactUs', payload).then((data) => {
      if (data.statusCode === 200 && data.data.isEmailSent === true) {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Message sent successfully',
            type: 'Success',
            message: 'Your message has been sent successfully, thank you!',
            buttonText: 'Ok'
          }
        });
          dialogRef.afterClosed().subscribe((status) => {
            this.router.navigate(['/']).then((response) => {
              window.location.reload();
            }
          );
        });
        this.contactUsForm.reset();
        this.contactUsForm.controls.name.setErrors(null);
        this.contactUsForm.controls.email.setErrors(null);
        this.contactUsForm.controls.message.setErrors(null);
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  execute(): void {
    this.captchaElem.execute();
  }

  privacyAndTerms(event: any) {
    this.checkedPrivacyAndTerms = event.source.checked;
  }

  onSubmit() {
    if (this.contactUsForm.valid) {
      let control: AbstractControl;
      control = this.contactUsForm.controls.email;
      if ( this.checkedPrivacyAndTerms === undefined) {
        this.checkedPrivacyAndTerms = false;
      }
      if (this.checkedPrivacyAndTerms) {
        this.execute();
      }
    } else {
      this.contactUsForm.markAllAsTouched();
    }
  }

}
